/**
 * Select input on focus
 * https://github.com/szimek/signature_pad
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

$(function(){

    "use strict";

    var $selector = 'select-on-focus'

    $("input[type=text],input[type=number],input[type=textarea],input[type=password]")
        .filterByData('select-on-focus')
        .focus(function(){
            $(this).select();
        })
        .mouseup(function (event) {
            event.preventDefault();
        });
});



// WEBPACK FOOTER //
// ./resources/js/services/jquery/jquery.select-on-focus.js